.card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: var(--color-grayscale-tuna);
  padding: 0.8rem;
  border-radius: 0.4rem;
  min-width: 0;

  @media screen and (min-width: $bp-medium) {
    padding: 1.2rem 2.4rem;
    flex-direction: row;
    gap: unset;
  }
}

.mobile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 2.4rem;

  @media screen and (min-width: $bp-medium) {
    width: unset;
  }
}

.logo-holder {
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--color-grayscale-white);
  border-radius: 0.6rem;
  width: 100%;
  padding: 0.8rem;
  aspect-ratio: 1;

  @media screen and (min-width: $bp-medium) {
    height: 100%;
    width: 38%;
    height: 7.6rem;
    padding: 0.8rem 1.6rem;
    aspect-ratio: unset;
  }
}

.logo {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.logo-placeholder {
  all: unset;
  aspect-ratio: 1;
  font-size: 2rem;
  font-weight: 600;
  color: var(--color-grayscale-trout);
  cursor: pointer;
  padding: 1.6rem;
  text-align: center;

  @media screen and (min-width: $bp-medium) {
    font-size: 3rem;
    line-height: 3.6rem;
    height: 4.4rem;
    aspect-ratio: unset;
  }
}

.menu-handle {
  position: absolute;
  top: 0.8rem;
  right: 0.8rem;
}

.text {
  font-weight: 500;
  font-size: 1.4rem;
  color: var(--color-grayscale-white);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media screen and (min-width: $bp-medium) {
    font-size: 2rem;
    line-height: 2.4rem;
  }
}
